// src/contexts/AuthContext.jsx
import { createContext, useState, useEffect, useContext } from 'react';
import api from "../api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [signed, setSigned] = useState(null); // null = carregando
  const [user, setUser] = useState(null);

  useEffect(() => {

    // Simula verificação no localStorage ou API
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      setSigned(true);
    } else {
      setSigned(false);
    }

  }, []);

  const signup = async (userData) => {
    
    const response = await api.post('/user', userData);
    const data_response = response.data;

    if (data_response.status === 0) {
      // retorna o erro para o handleSubmit decidir o que fazer
      return data_response;
    }

    // só seta signed se deu certo
    //setUser(data_response.data);
    //localStorage.setItem('user', JSON.stringify(data_response.data));
    //setSigned(true);

    return data_response;
  };

  const login = async (userData) => {

    const response = await api.post('auth',
        {
        email: userData['email'],
        password: userData['password'],
        }
    );
    let data_response = response.data;
    
    if(data_response['status'] == 0){
        alert(data_response['message']);
    }else{

        setUser(data_response['data']);
        localStorage.setItem('user', JSON.stringify(data_response['data']));
        setSigned(true);
        //api.defaults.headers.Authorization = data_response['data']['token'];
        
    }

  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    setSigned(false);
  };


  


  return (
    <AuthContext.Provider value={{ signed, user, login, logout, signup }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);